<template>
    <div>
        <template v-if="action=='view'">
            <div class="table-settings mb-4" v-if="allData.length>0 || q!=''">
                <div class="row align-items-center justify-content-between">
                    <div class="col col-md-6 col-lg-3 col-xl-4">
                    </div>
                    <div class="col-4 col-md-2  pl-md-0 text-right">
                    </div>
                </div>
            </div>
            <div class="card border-light shadow-sm mb-4">
                <div style="position: absolute; margin-top: 60px; z-index: 1; width: max-content; left: 50%; transform: translate(-50%, 0%);" v-if="!permissions.find(e => e.permission_name == 'View Option Value Types')">
                    <span style="color: red;"><i class="mr-2 fa fa-eye-slash"></i>You dont have the viewing permission.</span>
                </div>
                <div  v-if="(allData.length>0)" :style="!permissions.find(e => e.permission_name == 'View Option Value Types') ? 'filter: blur(4px); pointer-events: none;' : ''" >
                    <div class="card-body">
                    <table class="table table-hover">
                        <thead class="thead-light">
                            <tr>
                                <th>#</th>
                                <th>Type</th>
                                <!-- <th>Status</th>
                                <th>Action</th> -->
                            </tr>
                        </thead>
                        <tbody v-if="allData.length>0">
                            <tr v-for="(data,key) in allData" :key="key">
                                <td>
                                    <a href="#" class="font-weight-bold">
                                        {{key+1}}
                                    </a>
                                </td>
                                <td><span class="font-weight-normal">{{data.type}}</span></td>
                                <!-- <td>
                                    <span class="font-weight-bold">
                                        <a class="btn btn-danger btn-xs" href="#" @click="updateStatus(data, 1)" v-if="data.status==0"> Inactive</a>
                                        <a class="btn btn-success btn-xs" href="#" @click="updateStatus(data, 0)" v-if="data.status==1"> Active</a>
                                    </span>
                                </td>
                                <td>
                                    <div class="btn-group"> -->
                                        <!-- <router-link class="btn btn-success btn-xs" :to="{name : 'index', params: { page: 'subcategory', action: 'view', id: data.id,  code: data.id }}"><span class="fa fa-eye mr-2"></span>Subcategory</router-link> -->
                                        <!-- <router-link class="btn btn-primary btn-xs" :to="{name : 'index', params: { page: page, action: 'edit', id: data.id }}"><span class="fa fa-edit mr-2"></span>Edit</router-link> -->
                                        <!-- <a @click="remove(data.id)" class="btn btn-danger btn-xs" href="#"><span class="fa fa-trash-alt mr-2"></span>Remove</a> -->
                                    <!-- </div>
                                </td> -->
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td class="text-center" colspan="5">No record found</td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- <div class="card-footer px-3 border-0 d-flex align-items-center justify-content-between">
                        <nav aria-label="Page navigation example">
                            <ul class="pagination mb-0">
                                <template v-for="(paginate,key) in allData">
                                    <li :key="key" class="page-item" :class="{'active': paginate.active}" v-if="paginate.url">
                                        <a class="page-link" @click="viewAllUrl=paginate.url;allDatas(false)" v-html="paginate.label"></a>
                                    </li>
                                </template>
                            </ul>
                        </nav>
                        <div class="font-weight-bold small">Page <b>{{allData.current_page}}</b> of <b>{{allData.last_page}}</b> page Total record <b>{{allData.total}}</b></div>
                    </div> -->
                    
                    </div>
                </div>
                <div class="card-body text-center" v-else>
                    <div v-if="loading">
                        loading...
                    </div>
                    <div v-else>
                        <div>
                            <h3>Add and manage your {{page}}</h3>
                            <p>This is where you’ll add {{page}} and manage theme. You can also improve your website by adding.</p>
                            <router-link :to="{name : 'index', params: { page: page, action: 'add' }}" class="btn btn-primary" type="button">Add {{page}}</router-link>
                            <br><br><br>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="false">
            <div class="row">
                <div class="col-12 col-xl-8">
                    <div class="card card-body bg-white border-light shadow-sm mb-4">
                        <h2 class="h5 mb-4">General information</h2>
                        <div class="row">
                            <div :class="action == 'edit' ? 'col-md-6 mb-3' : 'col-md-12 mb-3'">
                                
                                <MssInput v-model="form.opt_type" placeholder="Enter Option Value Type Name" required></MssInput>
                            </div>
                             <div class="col-md-6 mb-3" v-if="action == 'edit'">
                                <MssInput v-model="form.id" disabled placeholder="Option Value Type Id"></MssInput>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-xl-4 sidebar-stricky">
                    <div class="card card-body bg-white border-light shadow-sm mb-4">
                        <h2 class="h5 mb-4">Visibility</h2>
                        <div class="row">
                            <div class="col-md-12 mb-3">
                                <MssInput type="switch" v-model="form.status" placeholder="Visible this to all"></MssInput>
                            </div>
                            <!-- <div class="col-md-12 mb-3">
                                <MssInput type="switch" v-model="form.is_featured" placeholder="Is Feature"></MssInput>
                            </div> -->
                            <div class="col-md-12 mb-3">
                                <div>
                                    <button @click="submit" class="btn btn-info btn-block" v-if="action=='add'">Publish</button>
                                    <button @click="submit" class="btn btn-success btn-block" v-else>Update</button>
                                </div>
                            </div>
                        </div>
                    </div>
    
                    <!-- <div class="card card-body bg-white border-light shadow-sm mb-4">
                            <div class="row">
                                <h2 class="col-md-8 h5 mb-4">SEO information</h2>
                                <div class="col-md-4 text-right">
                                    <button @click="defaultSEO=false;editSEO = editSEO ? false : true" class="btn btn-info btn-xs"><span class="far fa-edit mr-2"></span>Edit</button>
                                </div>
                            </div>
                            <div class="row" v-if="editSEO">
                                <div class="col-md-6 mb-3">
                                    <MssInput v-model="form.meta_title" placeholder="SEO title of this page"></MssInput>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <MssInput v-model="form.meta_keywords" placeholder="keywords for this page"></MssInput>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <MssInput type="textarea" v-model="form.meta_description" placeholder="Seo Description max 150 char"></MssInput>
                                </div>
                            </div>
                            <div v-else class="row align-items-center">
                                <h3>{{form.meta_title}}</h3>
                                <a href="javascript:;">{{URL_ROOT}}category/{{form.linkname}}</a>
                                <p>{{limitedword(striphtml(form.meta_description),150)}}</p>
    
                            </div>
                        </div> -->
                </div>
            </div>
        </template>
    </div>
    </template>
    
    <script>
    import {
        VueEditor
    } from "vue2-editor";
    import $ from 'jquery'
    import axios from 'axios'
    export default {
        components: {
            VueEditor
        },
        props: [
            "page", "action", "id", "type"
        ],
        data() {
            return {
                selectedCategory: null,
                isEditor: true,
                loading: false,
                allData: [],
                selected_files: [],
                form: {
                    id: null,
                    lorder: 0,
                    status: true,
                    heading: '',
                    photo: '',
                    is_parent: 0,
                    is_featured: true,
                    type: 'category_save',
                },
                editSEO: false,
                defaultSEO: true,
                pageList: [],
                fullToolbar: [
                    [{
                        'font': []
                    }],
                    [{
                        'header': [false, 1, 2, 3, 4, 5, 6, ]
                    }],
                    [{
                        'size': ['small', false, 'large', 'huge']
                    }],
                    ['bold', 'italic', 'underline', 'strike'],
                    [{
                        'align': [false, 'justify', 'center', 'right']
                    }],
                    [{
                        'list': 'ordered'
                    }, {
                        'list': 'bullet'
                    }, {
                        'list': 'check'
                    }],
                    [{
                        'indent': '-1'
                    }, {
                        'indent': '+1'
                    }],
                    [{
                        'color': []
                    }, {
                        'background': []
                    }],
                    ['link', 'image', 'video', 'formula'],
                    ['clean'],
                ],
                viewAllUrl: '',
                permissions: null,
            }
        },
        methods: {
            updateStatus(data, status) {
                var ev = this
                const updateData = {
                    val_id: data.id,
                    val_status: status,
                    type: 'updateValueTypes'
                }
                axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                    data: updateData
                }).then((response) => {
                    ev.$toasted.global[response.data.status]({
                        message: response.data.msg
                    })
                    ev.newAllDatas()
                })
            },
            update(table, status, id) {
                var param = {
                    id: id,
                    status: status,
                    table: table,
                    type: 'commonStatus'
                }
                axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'api.php',
                    data: param
                }).then(function (response) {
                    var data = response.data;
                    console.log('status', data)
                })
            },
            addInit() {
                this.getUnderof();
                this.reset()
            },
            editInit() {
                this.getDetail();
                // this.getUnderof();
            },
            viewInit() {
                this.newAllDatas()
            },
            reset() {
                this.form = {
                    id: null,
                    type: 'category_save',
                    lorder: 0,
                    status: true,
                    heading: '',
                    file: '',
                    is_parent: 0,
                    is_featured: true
                };
            },
            getUnderof() {
                var pList = [];
                pList.push({
                    label: 'Parent',
                    code: 0
                })
                axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'api.php?type=getCategory',
                }).then(function (response) {
                    var data = response.data;
                    $.each(data, function (key, param) {
                        pList.push({
                            label: param.heading,
                            code: param.id
                        })
                    })
                })
    
            },
            upload_file() {
                // var ev = this;
                this.file = this.$refs.file.files[0];
    
                // let formData = new FormData();
                // console.log(formData);
                // this.save_userimage();
    
            },
            // save_userimage: function () {
            //     var ev = this;
            //     this.file = this.$refs.file.files[0];
    
            //     let formData = new FormData();
    
            //     formData.append('photo', this.file);
            //     formData.append('id', this.id);
    
            //     if (this.file == undefined) {
            //         ev.$swal({
            //             message: "please upload image"
            //         });
            //     } else {
            //      if(this.action=='edit'){
            //         axios.post(this.$root.URL_ROOT + 'api.php?type=category_edit', formData, {
            //                 headers: {
            //                     'Content-Type': 'multipart/form-data'
            //                 }
            //             })
            //             .then(function (response) {
            //                 var data = response.data;
            //                 //console.log(data);
            //                 if (data.status == "success") {
            //                     ev.$swal({
            //                         title: data.msg,
            //                     });
            //                     // ev.getUserDetail();
    
            //                 } else {
            //                     ev.$swal({
            //                         title: data.msg,
            //         // text:data.msg
            //                     });
            //                 }
            //             })
            //     }
            //     }
    
            // },
            getDetail() {
                var ev = this
                var param = {
                    val_id: this.id
                }
                axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'updatedApiForProducts.php?type=fetchAllValueTypes',
                    data: param
                }).then(function (response) {
                    var data = response.data;
                    ev.form = {
                        id: data.data[0].id,
                        opt_type: data.data[0].type,
                        status: data.data[0].status
                    }
                })
            },
            async newAllDatas(id = null) {
                const params = id ? {
                    id,
                    type: 'fetchAllValueTypes'
                } : {
                    type: 'fetchAllValueTypes'
                }
                const response = await axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                    params
                })
                this.allData = response.data.data
            },
            allDatas() {
                this.newAllDatas()
                return
                var ev = this
                axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'api.php?type=getCategory',
                    data: {
                        page_no: 2,
                        limit: 5
                    }
                }).then(function (response) {
                    var data = response.data;
                    console.log(data);
                    ev.allData = data
                })
            },
            submit() {
                var ev = this
                // this.file = this.$refs.file.files[0];
                // this.file = this.$refs.front_image.files[0];
                // this.banner = this.$refs.banner.files[0];
    
                if (this.form.opt_type === '') {
                    this.$toasted.global.error({
                        message: 'Please enter a option value type.'
                    })
                }  else {
                    let status = ''
    
                    if (ev.form.status == true) {
                        status = 1
                    } else {
                        status = 0
                    }
                    // let formData = new FormData();
                    // if (this.action == 'edit') {
                    //     formData.append('cat_id', this.id);
                    //     // this.form.type = 'category_edit';
                    // }
                    // formData.append('image_collection', this.$refs.image_collection.files);
                    // for (var i = 0; i < this.$refs.image_collection.files.length; i++) {
                    //     let file = this.$refs.image_collection.files[i];
                    //     formData.append('image_collection[' + i + ']', file);
                    // }
                    // formData.append('lorder', this.form.lorder);
                    // formData.append('banner', this.banner);
                    // formData.append('photo', this.file);
                    // formData.append('cat_name', this.form.category_name);
                    // formData.append('cat_desc', this.form.category_description);
                    // formData.append('cat_status', status);
                    // formData.append('cat_price', this.form.price);
                    // formData.append('is_featured', this.form.is_featured);
                    // formData.append('type', this.form.type);
                    const data = this.action == 'edit' ? {
                        val_id: this.id,
                        val_type: this.form.opt_type,
                        val_status: status,
                        type: 'updateValueTypes'
                    } : {
                        val_type: this.form.opt_type,
                        val_status: status,
                        type: 'createValueTypes'
                    }
                    axios({
                        method: 'POST',
                        url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                        data: data
                    }).then(function (response) {
                        var data = response.data;
                        if (data.status == "success") {
                            ev.$swal({
                                toast: true,
                                position: 'top-end',
                                timer: 5000,
                                icon: 'success',
                                timerProgressBar: true,
                                title: 'Action perform successfully'
                            })
                            ev.$router.push({
                                name: 'index',
                                params: {
                                    page: ev.page,
                                    // action: 'edit',
                                    // id: response.data.id
                                }
                            })
                        } else {
    
                            setTimeout(() => ev.$swal(data.msg), 1000);
    
                        }
                    })
                }
            },
            remove(id) {
                var self = this;
                var param = {
                    id: id,
                    table: 'mss_category',
                    type: 'commonDelete'
                }
                this.$swal({
                    title: "Delete this ?",
                    text: "Are you sure? You won't be able to revert this!",
                    icon: 'info',
                    showCancelButton: true,
                    confirmButtonColor: "#f00",
                    confirmButtonText: "Yes, Delete it!",
                    reverseButtons: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios({
                            method: 'POST',
                            url: this.$root.URL_ROOT + 'api.php',
                            data: param
                        }).then(function (response) {
                            var data = response.data;
                            console.log('commonDelete', data)
                            self.allDatas()
                        })
                    }
                })
            }
        },
        mounted() {
            if (localStorage.getItem('permissions')) {
                const permissionsLS = localStorage.getItem('permissions')
                const permission = JSON.parse(permissionsLS)
                this.permissions = permission.filter(e => e.section == 'OPTION VALUE TYPES' && e.has_permission == true)
            }
            if (this.action == "view") {
                this.viewInit()
            } else if (this.action == "edit" && this.id > 0) {
                this.editInit()
            } else if (this.action == "add") {
                this.addInit();
            }
        },
        watch: {
            'action': function (val) {
                if (val == "view") {
                    this.viewInit()
                } else if (val == "edit" && this.id > 0) {
                    this.editInit()
                } else if (val == "add") {
                    this.addInit();
                }
            },
            'form.linkname': function (val) {
                var text = val.replace(' ', "")
                this.form.linkname = text
            },
            'loading': function (val) {
                if (val) {
                    this.$swal.showLoading();
                } else {
                    this.$swal.close()
                }
            },
            'q': function (newVal, oldVal) {
                if (newVal == '') {
                    this.viewAllUrl = this.URL_ROOT + 'admin/' + this.page + '/all';
                } else if (newVal != oldVal) {
                    this.viewAllUrl = this.URL_ROOT + 'admin/' + this.page + '/all/' + newVal;
                }
                this.allDatas(false);
            }
        }
    }
    </script>
    
    <style scoped>
    @import "~vue2-editor/dist/vue2-editor.css";
    </style>
    